import { Injectable } from '@angular/core';
import {
  StateService,
} from '@uirouter/angular';

import {
  AppRoute,
  AprimaTransitionRequest,
  WebViewManager,
} from 'webcommon/shared';

import { BridgeService } from '../BridgeService';
import { BrowserWebViewManager } from './BrowserWebViewManager';
import { RouteFormatterService } from './RouteFormatterService';

interface NavigateCommand {
  state: string;
  opts: string;
}

@Injectable({
  providedIn: 'root',
})
export class XamarinWebViewManager implements WebViewManager {
  constructor(
    private bridgeService: BridgeService,
    private browserWebViewManager: BrowserWebViewManager,
    private routeFormatterService: RouteFormatterService,
    private stateService: StateService,
  ) {
  }

  bootstrap(): void {
    this.bridgeService.on<NavigateCommand>('navigate').subscribe(d => this.onNavigate(d));
  }

  private onNavigate(d: NavigateCommand) {
    if (d) {
      const opts = JSON.parse(d.opts);

      this.browserWebViewManager.activateState(d.state, {
        appRoute: d.state,
        opts,
      });
    }
  }

  private completeRoute(appState: AppRoute): string {
    const parentSeperator = appState.state.lastIndexOf('.');

    if (parentSeperator > 0) {
      const parentState = this.stateService.get(appState.state.substring(0, parentSeperator));

      if (!parentState.name || !parentState.url) {
        throw new Error('Invalid parent state');
      }

      return this.completeRoute({state: parentState.name, route: parentState.url}) + appState.route;
    } else {
      return appState.route;
    }
  }

  private getRoute(appRoute: AppRoute, transition: AprimaTransitionRequest): string {
    if (!appRoute.route) {
      return '';
    }

    const completedRoute = this.completeRoute(appRoute);
    const parentRoutePattern = this.stateService.get('^').url;

    if (!parentRoutePattern) {
      throw new Error('Invalid result for ^');
    }
    return this.routeFormatterService.formatRelativeRoute(completedRoute, parentRoutePattern, transition.opts);
  }

  activateView(appRoute: AppRoute, transition: AprimaTransitionRequest): boolean {
    const route = this.getRoute(appRoute, transition);

    try {
      this.bridgeService.fireEvent('navigate', {
        command: {
          Route: route,
          Page: '/index.html',
          State: appRoute.state,
          ListUiControlName: appRoute.listUiControlName,
          Options: JSON.stringify(transition.opts),
          PageOptions: JSON.stringify(transition.pageOpts)
        },
      });
    } catch (e: any) {
      console.warn(e.message);
    }

    return true;
  }

  goBack(): void {
    this.bridgeService.fireEvent('goBack', {});
  }
}
